var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("send-via-sendcloud")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-autocomplete", {
                    attrs: {
                      items: _vm.filteredShippingMethods,
                      label: _vm.$ct("shipping-method"),
                    },
                    on: {
                      "item-click": function ($event) {
                        return _vm.onItemClicked($event)
                      },
                      focus: function ($event) {
                        _vm.shippingMethodSearchInput = ""
                      },
                      blur: function ($event) {
                        return _vm.onShippingMethodBlur()
                      },
                    },
                    model: {
                      value: _vm.shippingMethodSearchInput,
                      callback: function ($$v) {
                        _vm.shippingMethodSearchInput = $$v
                      },
                      expression: "shippingMethodSearchInput",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { label: _vm.$ct("name") },
                    model: {
                      value: _vm.parcel.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.parcel, "name", $$v)
                      },
                      expression: "parcel.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { label: _vm.$ct("company-name") },
                    model: {
                      value: _vm.parcel.company_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.parcel, "company_name", $$v)
                      },
                      expression: "parcel.company_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { label: _vm.$ct("address") },
                    model: {
                      value: _vm.parcel.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.parcel, "address", $$v)
                      },
                      expression: "parcel.address",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "4" } },
                [
                  _c("w-input", {
                    attrs: { label: _vm.$ct("postal-code") },
                    model: {
                      value: _vm.parcel.postal_code,
                      callback: function ($$v) {
                        _vm.$set(_vm.parcel, "postal_code", $$v)
                      },
                      expression: "parcel.postal_code",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "8" } },
                [
                  _c("w-input", {
                    attrs: { label: _vm.$ct("city") },
                    model: {
                      value: _vm.parcel.city,
                      callback: function ($$v) {
                        _vm.$set(_vm.parcel, "city", $$v)
                      },
                      expression: "parcel.city",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-country-code-autocomplete", {
                    attrs: { label: _vm.$ct("country") },
                    model: {
                      value: _vm.parcel.country,
                      callback: function ($$v) {
                        _vm.$set(_vm.parcel, "country", $$v)
                      },
                      expression: "parcel.country",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { label: _vm.$ct("email") },
                    model: {
                      value: _vm.parcel.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.parcel, "email", $$v)
                      },
                      expression: "parcel.email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { label: _vm.$ct("weight") },
                    model: {
                      value: _vm.parcel.weight,
                      callback: function ($$v) {
                        _vm.$set(_vm.parcel, "weight", $$v)
                      },
                      expression: "parcel.weight",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.isCreatingLabel, icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.createLabel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("create-label")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }